// extracted by mini-css-extract-plugin
export var askAiIcon = "_qi-9";
export var container = "_qi-0";
export var groupSeparator = "_qi-a";
export var highlight = "_qi-4";
export var resultIcon = "_qi-5";
export var resultItem = "_qi-7";
export var resultSubtitle = "_qi-3";
export var resultTitle = "_qi-2";
export var resultsList = "_qi-1";
export var searchGroup = "_qi-6";
export var selected = "_qi-8";